<script setup lang="ts">
    import { useCompanyCommentsData } from '@/composables/useCompanyCommentsData';
    import CommentsSkeleton from '@/components/company-comments/CommentsSkeleton.vue';
    import CommentsMessage from '@/components/company-comments/CommentsMessage.vue';
    import { onMounted, watch, ref, nextTick } from 'vue';

    const props = defineProps<{
        companyId: number;
        commentCount: number;
    }>();

    const { comments, isLoadingComments } = useCompanyCommentsData(props.companyId);

    const scrollContainer = ref<HTMLElement | null>(null);

    onMounted(() => {
        scrollToBottom();
    });

    watch(comments, async () => {
        await nextTick();
        scrollToBottom();
    });

    function scrollToBottom() {
        if (scrollContainer.value) {
            scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
        }
    }
</script>

<template>
    <div
        ref="scrollContainer"
        class="no-scrollbar flex h-full max-h-128 min-h-32 w-full flex-col gap-7 overflow-y-auto pb-5"
    >
        <CommentsSkeleton v-if="isLoadingComments && commentCount > 0" />
        <CommentsMessage
            v-else
            v-for="comment in comments"
            :key="comment.id"
            :comment="comment"
        />
    </div>
</template>
